






















































































import Vue from 'vue'
import { mapState } from 'vuex'

import VButton from '@/components/button/basic-button.vue'
import UnitPanel from '@/components/unit-panel/unit-panel.vue'
import ImplView from '@/views/units/components/ImplView.vue'

import { getQuestionByName } from '@/api/question'

interface Data {
  content: api.content.Content | undefined
  unit: model.Unit | undefined
  impl: api.question.GetQuestionByNameResponse['impl'] | undefined
}

export default Vue.extend({
  components: {
    VButton,
    UnitPanel,
    ImplView
  },

  data(): Data {
    return {
      content: undefined,
      unit: undefined,
      impl: undefined
    }
  },

  created() {
    this.fetchData()
  },

  computed: {
    ...mapState(['loading', 'user']),

    currentQuestion(): api.question.GetQuestionByNameResponse['impl']['questions'][0] {
      return this.impl!.questions[0]
    }
  },

  methods: {
    async fetchData() {
      this.$store.dispatch('loading')

      const qname = this.$route.query.qname
      if (!qname || Array.isArray(qname)) {
        this.$store.dispatch('loading', false)
        return
      }

      const res = await getQuestionByName(qname)

      this.content = res.content
      this.unit = res.unit
      this.impl = res.impl

      this.$store.dispatch('setTitle', this.unit.title)
      this.$store.dispatch('loading', false)
    }
  }
})
